import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/shared/ui/dropdown-menu";
import { Button } from "@/shared/ui/button";
import { LucideIcon } from "lucide-react";

interface DropdownItem {
  label: string;
  icon: LucideIcon;
  variant: 'default' | 'destructive';
  onClick: () => void;
}

interface DropdownProps {
  triggerIcon: LucideIcon;
  items: DropdownItem[];
}

const Dropdown = ({ triggerIcon, items }: DropdownProps) => {
  const TriggerIcon = triggerIcon;
  return (
    <>
      {items.length > 0 && (
        <>
          <div className="flex items-center space-x-2">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="gap-2">
                  <TriggerIcon className="h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {items.length > 0 && items.map((item) => {
                  const ItemIcon = item.icon;
                  return (
                    <DropdownMenuItem
                      key={item.label}
                      className={`text-sm gap-2 ${item.variant === 'destructive' ? 'text-destructive hover:text-destructive' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        item.onClick();
                      }}>
                      <ItemIcon className="h-4 w-4" />
                      {item.label}
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </>
      )}
    </>
  );
};

export default Dropdown; 